<template>
  <div
    v-if="badgesForShowing(showing).length > 2"
    style="display: flex; position: relative; overflow: hidden; width: 60px;"
  >
    <div
      class="marquee"
      :style="{ 'animation-duration': `${2 * badgesForShowing(showing).length}s` }"
    >
      <showing-badge
        v-for="badge in badgesForShowing(showing)"
        :key="'1-' + badge.id"
        :showing-badge="badge"
        :color="color"
        :size="size"
        class="text-bold q-pa-none bg-transparent"
      />
      <showing-badge
        v-for="badge in badgesForShowing(showing)"
        :key="'2-' + badge.id"
        :showing-badge="badge"
        :color="color"
        :size="size"
        class="text-bold q-pa-none bg-transparent"
      />
      <showing-badge
        v-for="badge in badgesForShowing(showing)"
        :key="'3-' + badge.id"
        :showing-badge="badge"
        :color="color"
        :size="size"
        class="text-bold q-pa-none bg-transparent"
      />
      <showing-badge
        v-for="badge in badgesForShowing(showing)"
        :key="'4-' + badge.id"
        :showing-badge="badge"
        :color="color"
        :size="size"
        class="text-bold q-pa-none bg-transparent"
      />
    </div>
  </div>
  <div
    v-else
    style="display: flex; overflow: hidden;"
  >
    <showing-badge
      v-for="badge in badgesForShowing(showing)"
      :key="badge.id"
      :showing-badge="badge"
      :color="color"
      :size="size"
      class="text-bold q-pa-none bg-transparent"
    />
  </div>
</template>

<script>
import ShowingBadge from 'src/modules/admin/showing-badge/components/ShowingBadge'
export default {
  name: 'ShowingBadges',
  components: {
    ShowingBadge
  },
  props: {
    showing: {
      type: Object,
      required: true
    },
    color: {
      type: String,
      required: false,
      default: 'white'
    },
    size: {
      type: String,
      required: false,
      default: 'md'
    }
  },
  methods: {
    badgesForShowing (showing) {
      return _.filter(showing.showingBadges.data, badge => badge.displayOnSignage)
    }
  }
}

</script>

<style scoped>

@keyframes marquee {
    0%   { transform: translate(0, 0); }
    100% { transform: translate(-25%, 0); }
}

.marquee {
  position: absolute;
  left: -25%;
  white-space: nowrap;
  /* The animation-duration should be overridden */
  animation: marquee 0s linear infinite;
}

.marquee span {
  margin-right: 20px;
}
</style>
